import { useState, useEffect } from 'react';

const GROUP_IDENTIFIER = "faa2a1cf-b8dc-42ad-8346-5af7b66ae063";

const useExp360Script = () => {
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
    const [scriptError, setScriptError] = useState(false);

    useEffect(() => {
        if(!window.exp360) {
            const script = document.createElement('script');

            script.src = `https://cdn.exp360.com/embed/js/exp360-embed-2.3.18.js?d=${GROUP_IDENTIFIER}&p=web&t=setTrackingIdWhenKnown`;
            script.async = true;

            script.addEventListener('load', function () {
                setIsScriptLoaded(true);
            });
            script.addEventListener('error', function (e) {
                console.error("there has been an error with loading the script", e);
                setScriptError(true);
            });

            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            }
        }
        else {
            setIsScriptLoaded(true);
        }
    }, []);

    return {isScriptLoaded, scriptError};
};

export default useExp360Script;